module.exports = __webpack_public_path__ + "static/media/apiProjectStruct.32e8ef03.png";